import { Box, HStack, Text } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { AiOutlineArrowLeft } from 'react-icons/ai';
import { Link } from '@/components/elements/Link/Link';

export type SubHeaderProps = {
  backTo: string;
};

export const SubHeader: FC<SubHeaderProps> = ({ backTo }) => {
  const router = useRouter();

  const handleClick = () => {
    if (window.history.length <= 1) {
      router.push(backTo);
    } else {
      router.back();
    }
  };

  return (
    <Box paddingY={4}>
      <Link onClick={handleClick} color="textDark" display="inline-block">
        <HStack spacing={1}>
          <AiOutlineArrowLeft size={22} />
          <Text fontSize="sm">戻る</Text>
        </HStack>
      </Link>
    </Box>
  );
};

SubHeader.displayName = 'SubHeader';
